var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14C8.53043 14 9.03914 13.7893 9.41421 13.4142C9.78929 13.0391 10 12.5304 10 12C10 11.4696 9.78929 10.9609 9.41421 10.5858C9.03914 10.2107 8.53043 10 8 10C7.46957 10 6.96086 10.2107 6.58579 10.5858C6.21071 10.9609 6 11.4696 6 12C6 12.5304 6.21071 13.0391 6.58579 13.4142C6.96086 13.7893 7.46957 14 8 14ZM18 14C18.5304 14 19.0391 13.7893 19.4142 13.4142C19.7893 13.0391 20 12.5304 20 12C20 11.4696 19.7893 10.9609 19.4142 10.5858C19.0391 10.2107 18.5304 10 18 10C17.4696 10 16.9609 10.2107 16.5858 10.5858C16.2107 10.9609 16 11.4696 16 12C16 12.5304 16.2107 13.0391 16.5858 13.4142C16.9609 13.7893 17.4696 14 18 14Z",
    stroke: "black",
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.05 12H15V1.6C15 1.44087 14.9368 1.28826 14.8243 1.17574C14.7117 1.06321 14.5591 1 14.4 1H1M5.65 12H3.6C3.52121 12 3.44319 11.9845 3.37039 11.9543C3.29759 11.9242 3.23145 11.88 3.17574 11.8243C3.12002 11.7685 3.07583 11.7024 3.04567 11.6296C3.01552 11.5568 3 11.4788 3 11.4V6.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H6",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H20.61C20.726 4.00003 20.8395 4.03367 20.9367 4.09685C21.034 4.16003 21.1108 4.25005 21.158 4.356L22.948 8.384C22.9821 8.46048 22.9998 8.54326 23 8.627V11.4C23 11.4788 22.9845 11.5568 22.9543 11.6296C22.9242 11.7024 22.88 11.7685 22.8243 11.8243C22.7685 11.88 22.7024 11.9242 22.6296 11.9543C22.5568 11.9845 22.4788 12 22.4 12H20.5M15 12H16",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckBlack);
export default __webpack_public_path__ + "static/media/truck-black.d8f665df466df1f36f03ea7aaf73da8f.svg";
export { ForwardRef as ReactComponent };